import type { PropsWithChildren } from "react";

import * as stylex from "@stylexjs/stylex";

import { type PropsWithStyleX, colors } from "../../styles/tokens.stylex";
import Typography from "../Typography";

export type ErrorMessageType = PropsWithChildren<PropsWithStyleX> & {
    errorMessage?: string;
};

export default function ErrorMessage({ errorMessage, styleX }: ErrorMessageType) {
    return errorMessage ? (
        <Typography fontStyle="BodyS" styleX={[styles.error, styleX]}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...stylex.props(styles.errorIcon)}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.85489 0.707915C5.35583 -0.187671 6.64455 -0.187825 7.14571 0.707637L11.8197 9.05911C12.3093 9.93399 11.6769 11.0126 10.6744 11.0126H1.32905C0.326611 11.0126 -0.305793 9.93426 0.183563 9.05939L4.85489 0.707915ZM7.00019 7.00009V3.00009H5.00019V7.00009H7.00019ZM5.99984 10.0001C6.55194 10.0001 6.9995 9.55238 6.9995 9.00009C6.9995 8.44781 6.55194 8.00009 5.99984 8.00009C5.44775 8.00009 5.00019 8.44781 5.00019 9.00009C5.00019 9.55238 5.44775 10.0001 5.99984 10.0001Z"
                    fill="#DC2626"
                />
            </svg>
            {errorMessage}
        </Typography>
    ) : null;
}

const styles = stylex.create({
    error: {
        color: colors.b_Error,
        display: "flex",
        alignItems: "center",
        gap: "0.5em",
    },
    errorIcon: {
        height: "1em",
        width: "1em",
    },
});
